module.exports = __webpack_public_path__ + "static/img/community.75f2783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/community.png
// module id = 165
// module chunks = 180